import { useEffect, useState } from "react";
import { Autocomplete, Box, TextField, Checkbox } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

import { getLegalFileStages } from "../../services/LegalFileStageService";
import { colorForStage } from "../../config/legalFileStages";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function LegalFileStageFilter({
  value,
  onChange,
  label = "Etapa del expediente",
  size,
}) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let active = true;
    setLoading(true);
    getLegalFileStages()
      .then((res) => {
        if (!active) return;
        const data = (res.data?.data || [])
          .slice()
          .sort((a, b) => a.order - b.order);
        setOptions(data);
      })
      .catch(() => {})
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <Autocomplete
      multiple
      size={size}
      loading={loading}
      disableCloseOnSelect
      options={options}
      value={value}
      isOptionEqualToValue={(option, val) => option.id === val.id}
      getOptionLabel={(option) => option.name}
      onChange={(_, newValue) => onChange(newValue)}
      renderOption={(props, option, { selected }) => {
        const { key, ...rest } = props;
        return (
          <li key={key} {...rest}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              checked={selected}
              size="small"
              sx={{ mr: 1 }}
            />
            <Box
              sx={{
                width: 9,
                height: 9,
                borderRadius: "50%",
                bgcolor: colorForStage(option),
                mr: 1,
                flexShrink: 0,
              }}
            />
            {option.name}
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder="Todas" />
      )}
    />
  );
}
